import React from "react";
import logo from "../img/logo.png";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { deepPurple } from "@mui/material/colors";
import { Link } from "react-router-dom";
const Header = () => {
  return (
    <div className="header">
      <div className="logo-area">
        <img src={logo} alt="logo" />
        <p>Metin Çevener</p>
      </div>
      <div className="right-area">
        <div className="notofications">
          <i class="ri-notification-line"></i>
        </div>
        <Link to={"/logout"}>
          <div className="profiles">
            <Stack direction="row" spacing={2}>
              <Avatar
                sx={{
                  bgcolor: deepPurple[500],
                  width: 35,
                  height: 35,
                  cursor: "pointer",
                }}
              >
                M
              </Avatar>
            </Stack>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Header;
